import { z } from 'zod';

export const stringNotEmptySchema = z
  .string()
  .transform((val) => val.trim())
  .refine((val) => val.length > 0, 'Whoops. You forgot this.');

export const stringNotEmptySchemaWithMessage = (message: string) =>
  z
    .string()
    .transform((val) => val.trim())
    .refine((val) => val.length > 0, message);

export const stringDefaultEmptySchema = z.string().default('');

export function getStringRegexPhoneSchema({
  isPhoneRequired = true
}: {
  isPhoneRequired?: boolean;
}) {
  if (!isPhoneRequired) {
    return z
      .string()
      .max(25)
      .transform((val) => val.trim())
      .refine(
        (val) =>
          val === '' ||
          (val.length > 0 && val.match(/^([+]?[\s0-9]+)?(\d{3}|[(]?[0-9]+[)])?([-]?[\s]?[0-9])+$/)),
        `Uh oh. This info doesn't look right.`
      );
  }
  return (
    z
      .string()
      .max(25)
      .transform((val) => val.trim())
      // TODO: customize required error message later
      // .refine((val) => val.length > 0, 'Whoops. You forgot this.')
      .refine(
        (val) =>
          val.length > 0 && val.match(/^([+]?[\s0-9]+)?(\d{3}|[(]?[0-9]+[)])?([-]?[\s]?[0-9])+$/),
        `Please enter a valid Phone Number`
      )
  );
}

export const pcccSchema = z
  .string()
  .max(25)
  .transform((val) => val.trim())
  .refine((val) => val.length > 0, 'Please enter your PCCC or Passport Number');
